import Button from "@pathwright/ui/src/components/button/Button"
import DropdownItem from "@pathwright/ui/src/components/dropdown/DropdownItem"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import useClipboard from "@pathwright/web/src/modules/clipboard/useClipboard"
import PathScheduleLabel from "@pathwright/web/src/modules/path/ui/PathScheduleLabel"
import classnames from "classnames"
import React from "react"
import "./PathItemControlComponents.css"

// REUSABLE CONTROL COMPONENTS

export const InlineItemComponent = function (props) {
  const {
    icon,
    label,
    to,
    handler,
    count,
    indicator,
    className,
    style,
    styles
  } = props
  return (
    <Tooltip className={className} title={label} style={style}>
      <Button
        {...(styles || {})}
        to={to}
        onClick={handler}
        icon={icon}
        label={count}
        indicator={indicator}
      />
    </Tooltip>
  )
}

InlineItemComponent.displayName = "InlineItemComponent"

export const DropdownItemComponent = function (props) {
  const { icon, label, handler, to } = props
  return (
    <DropdownItem
      style={{ color: "#444" }}
      icon={icon}
      label={label}
      to={to}
      onClick={handler}
    />
  )
}

DropdownItemComponent.displayName = "DropdownItemComponent"

export const DragItemComponent = function (props) {
  const { icon, label, dragHandleProps, to, className, styles } = props
  const style = {
    width: "30px",
    height: "30px",
    lineHeight: "30px",
    color: styles.inverted ? "#fff" : styles.color,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

  return (
    <div {...Object.assign({}, dragHandleProps)}>
      <Tooltip className={className} title={label}>
        <div className="PathListItemDrag" style={style}>
          <Pathicon icon={icon} />
        </div>
      </Tooltip>
    </div>
  )
}

DragItemComponent.displayName = "DragItemComponent"

export const DatesItemComponent = function (props) {
  const { icon, label, to, item, mode, className, styles } = props
  const noSchedule = !item.due && !item.starts

  return (
    <Tooltip
      className={classnames(className, { [`${className}--blank`]: noSchedule })}
      title={label}
    >
      <Button {...Object.assign({}, styles, { size: "medium", to: to })}>
        <PathScheduleLabel
          pathItem={item}
          showIcon
          mode={PathScheduleLabel.modes.actionable}
        />
      </Button>
    </Tooltip>
  )
}

DatesItemComponent.displayName = "DatesItemComponent"

export const CopyItemComponent = ({
  className,
  item,
  icon,
  label,
  to,
  styles
}) => {
  const [tooltip, setTooltip] = React.useState(label)
  const clipboard = useClipboard()

  const handleCopyToClipboard = () => {
    const copiedItemLabel = item.step_verb
      ? `${_.capitalize(item.step_verb)}: ${item.name}`
      : item.name
    clipboard.copy({
      object_type: item.item_type,
      object_id: item.id,
      object_label: copiedItemLabel
    })
  }

  const handleHide = () => {
    setTooltip(label)
  }

  const handleCopy = (e) => {
    setTooltip("Copied!")
    return handleCopyToClipboard(e)
  }

  return (
    <Tooltip
      closeOnTriggerClick={false}
      className={className}
      onHide={handleHide}
      title={tooltip}
    >
      <Button
        {...Object.assign({}, styles, {
          size: "medium",
          to: to,
          onClick: handleCopy
        })}
      >
        <Pathicon icon={icon} />
      </Button>
    </Tooltip>
  )
}

CopyItemComponent.displayName = "InlineItemComponent"
